import React, { useEffect } from 'react'
import { trackEvent } from '@/libs/functions/track'
import goTo from '@/libs/functions/goTo'
import { useModuleLang } from '@/libs/hooks/useLang'

// const isLocalStorageAvailable = () => {
//   try {
//     const testKey = '__test__'
//     window.localStorage.setItem(testKey, testKey)
//     window.localStorage.removeItem(testKey)
//     return true
//   } catch (e) {
//     return false
//   }
// }

const storageError = () => {
  const [prompTrans] = useModuleLang(['prompt_util'])
  // useEffect(() => {
  //   try {
  //     if (!isLocalStorageAvailable()) {
  //       throw new Error('localStorage is disabled or full')
  //     }
  //     const storageErrorCount = window.localStorage.getItem('storageErrorCount')
  //     window.localStorage.setItem('storageErrorCount', '1')
  //   } catch (error) {
  //     goTo(
  //       `/error/cookie?referrer=${encodeURIComponent(window.location.href)}`,
  //       {
  //         type: 'replace',
  //       },
  //     )
  //     trackEvent('cookieError:demo', {
  //       meta: {
  //         href: window.location.href,
  //         error: JSON.stringify(error),
  //       },
  //     })
  //   }
  // }, [])
  return (
    <div>
      <h1>storageError</h1>
      <p>{prompTrans('contactCustomer')}</p>
    </div>
  )
  return <div>storageError</div>
}

export default storageError
